import { render, staticRenderFns } from "./GlobalAllergensModal.vue?vue&type=template&id=c92a5b18"
import script from "./GlobalAllergensModal.vue?vue&type=script&lang=ts"
export * from "./GlobalAllergensModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports